module.exports = __webpack_public_path__ + "static/media/revert.9b0cbc68.svg";